import Vue from 'vue';
import pkg from '../../package.json';

// Stale-build prompt. The v1 API stamps Latest-App-Version on every response
// (it re-reads app.my247ed.com/version.txt every five minutes), so a tab
// learns about a new build on its next API call at no extra cost. A failed
// lazy route chunk (webpack's hashed filenames vanish on redeploy) is treated
// the same way instead of leaving a blank page. Reload is only ever suggested:
// App.vue renders <AppUpdatePrompt> while promptOpen is true.

const SNOOZE_MS = 30 * 60 * 1000;
const CHUNK_ERROR = /Loading (CSS )?chunk|ChunkLoadError|Failed to fetch dynamically imported module/i;

export const versionState = Vue.observable({
    current: pkg.version,
    latest: null,
    stale: false,
    promptOpen: false
});

let snoozedUntil = 0;

function openPrompt() {
    if (versionState.promptOpen) return;
    if (Date.now() < snoozedUntil) return;
    versionState.promptOpen = true;
}

function markStale(latest) {
    if (latest) versionState.latest = latest;
    versionState.stale = true;
    openPrompt();
}

function onFocus() {
    if (document.visibilityState === 'hidden') return;
    if (versionState.stale) openPrompt();
}

export function reloadApp() {
    window.location.reload();
}

export function snoozePrompt() {
    versionState.promptOpen = false;
    snoozedUntil = Date.now() + SNOOZE_MS;
}

export function installVersionCheck({ axiosInstance, router }) {
    axiosInstance.interceptors.response.use(
        (response) => {
            const latest = response.headers && response.headers['latest-app-version'];
            if (latest && latest !== pkg.version) {
                if (!versionState.stale) console.warn(`The app is out of date. App version: ${pkg.version}, Latest version: ${latest}`);
                markStale(latest);
            }
            return response;
        },
        (error) => Promise.reject(error)
    );

    router.onError((err) => {
        if (CHUNK_ERROR.test((err && err.message) || '')) {
            console.warn('A page failed to load because the running build is stale.');
            markStale();
        }
    });

    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onFocus);
}
